import { render } from "./Porters.vue?vue&type=template&id=4cf9468d&scoped=true"
import script from "./Porters.vue?vue&type=script&lang=js"
export * from "./Porters.vue?vue&type=script&lang=js"

import "./Porters.vue?vue&type=style&index=0&id=4cf9468d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf9468d"]])

export default __exports__